import React from 'react';

export const UpTrend = () => <div className={'up-trend'}/>;
